import { render, staticRenderFns } from "./OnDeviceIncidentsTable.vue?vue&type=template&id=46c85d44&"
import script from "./OnDeviceIncidentsTable.vue?vue&type=script&lang=js&"
export * from "./OnDeviceIncidentsTable.vue?vue&type=script&lang=js&"
import style0 from "./OnDeviceIncidentsTable.vue?vue&type=style&index=0&id=46c85d44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports